const routes = [
    /**
     * 活动路由
     */
    {
        "path":"/superdeer-activity/sell-membership",
        "name":"sell-membership",
        "meta":{"title":"超鹿月卡","headerType":5},
        component:() => import('../views/superdeer-activity/sell-membership/index')
    },
     {
        "path":"/superdeer-activity/sell-membership/moon-card-shop",
        "name":"sell-membership-moon-card-shop",
        "meta":{"title":"超鹿月卡商城","headerType":5},
        component:() => import('../views/superdeer-activity/sell-membership/moon-card-shop')
    },
    {
        "path":"/superdeer-activity/sell-membership/nolimit",
        "name":"sell-membership-nolimit",
        "meta":{"title":"超鹿自助团课卡","headerType":5},
        component:() => import('../views/superdeer-activity/sell-membership/index-nolimit')
    },
    {
        "path":"/superdeer-activity/sell-membership/index-violations",
        "name":"sell-membership",
        "meta":{"title":"超鹿月卡违规账号处罚公示","headerType":5},
        component:() => import('../views/superdeer-activity/sell-membership/index-violations')
    },
    {
        "path":"/superdeer-activity/sell-membership/schedule-month",
        "name":"sell-membership",
        "meta":{"title":"超鹿包月团课卡","headerType":5},
        component:() => import('../views/superdeer-activity/sell-membership/schedule-month')
    },
    {
        "path":"/superdeer-activity/sell-membership/star-coach",
        "name":"star-coach",
        "meta":{"title":"团课明星教练","headerType":5},
        component:() => import('../views/superdeer-activity/sell-membership/star-coach')
    },
    {
        "path":"/superdeer-activity/sell-membership/self",
        "name":"sell-membership-self",
        "meta":{"title":"超鹿自助健身卡","headerType":5},
        component:() => import('../views/superdeer-activity/sell-membership/self')
    },
    {
        "path":"/superdeer-activity/sell-membership/schedule",
        "name":"sell-membership-schedule",
        "meta":{"title":"超鹿团课健身卡","headerType":5},
        component:() => import('../views/superdeer-activity/sell-membership/schedule')
    },
    {
        "path":"/superdeer-activity/sell-membership/coach",
        "name":"sell-membership-coach",
        "meta":{"title":"超鹿包月私教","headerType":5},
        component:() => import('../views/superdeer-activity/sell-membership/coach')
    },
    {
      "path":"/superdeer-activity/sell-membership/coach-specialbag",
      "name":"sell-membership-coach-specialbag",
      "meta":{"title":"包月私教卡特殊课包","headerType":5},
      component:() => import('../views/superdeer-activity/sell-membership/coach-specialbag')
    },
    {
      "path":"/superdeer-activity/sell-membership/coach-upgrade",
      "name":"sell-membership-coach-upgrade",
      "meta":{"title":"包月私教卡升级","headerType":5},
      component:() => import('../views/superdeer-activity/sell-membership/coach-upgrade')
    },
    {
      "path":"/superdeer-activity/sell-membership/monthcard-upgrade",
      "name":"sell-membership-coach-monthcard-upgrade",
      "meta":{"title":"超鹿月卡升级","headerType":5},
      component:() => import('../views/superdeer-activity/sell-membership/monthcard-upgrade')
    },
    {
        "path":"/superdeer-activity/sell-membership/coupon",
        "name":"sell-membership",
        "meta":{"title":"我的自助优惠卡","headerType":4},
        component:() => import('../views/superdeer-activity/sell-membership/coupon')
    },
     {
        "path":"/superdeer-activity/sell-membership/card-use-venue",
        "name":"sell-membership-card-use-venue",
        "meta":{"title":"权益门店","headerType":5},
        component:() => import('../views/superdeer-activity/sell-membership/card-use-venue')
    },
    {
        "path":"/superdeer-activity/sell-membership/course-upgrade",
        "name":"sell-membership-course-upgrade",
        "meta":{"title":"课包升级","headerType":5},
        component:() => import('../views/superdeer-activity/sell-membership/course-upgrade/index')
    },
    {
        "path":"/superdeer-activity/sell-membership/course-upgrade-detail",
        "name":"sell-membership-course-upgrade-detail",
        "meta":{"title":"课包升级","headerType":5},
        component:() => import('../views/superdeer-activity/sell-membership/course-upgrade/detail')
    },
    // 青少年体育 私教专题页
    {
        "path":"/superdeer-activity/groupCoach",
        "name":"groupCamp",
        "meta":{"title":"青少年体育全项提升","headerType":4},
        component:() => import('../views/superdeer-activity/group-coach-2022/index')
    },
    {
        "path":"/superdeer-activity/new-people",
        "name":"new-people",
        "meta":{"title":"新人福利","headerType":4},
        component:() => import('../views/superdeer-activity/new-people-2022/index')
    },
    {
        "path":"/superdeer-activity/new-people/home",
        "name":"new-people-home",
        "meta":{"title":"新人福利","headerType":4},
        component:() => import('../views/superdeer-activity/new-people-2022/home')
    },
    {
        "path":"/superdeer-activity/recruitment",
        "name":"recruitment",
        "meta":{"title":"超鹿招聘","headerType":4},
        component:() => import('../views/superdeer-activity/recruitment/index')
    },
    {
        "path":"/superdeer-activity/free-train",
        "name":"free-train",
        "meta":{"title":"免费领取训练计划","headerType":4},
        component:() => import('../views/superdeer-activity/recruitment/free-train')
    },
    {
        "path": "/superdeer-activity/micro-popularize",
        "name": "micro-popularize",
        "meta": { "title": "超鹿燃脂小班课·公开课", "headerType": 4 },
        component:() => import('../views/superdeer-activity/recruitment/micro-popularize')
    },
    /**
     * 常驻路由
     */
    // 团课月卡-2022
    {
        "path":"/month-card/my-card",
        "name":"month-card-my-card",
        "meta":{"title":"我的卡包","headerType":5,keepAlive:true},
        component:() => import('../views/month-card/my-card')
    },
    {
      "path":"/month-card/auto-renew-manage",
      "name":"auto-renew-manage",
      "meta":{"title":"自动续费管理","headerType":5,keepAlive:true},
      component:() => import('../views/month-card/auto-renew-manage')
    },
    {
        "path":"/month-card/sell-record",
        "name":"month-card-sell-record",
        "meta":{"title":"开卡记录","headerType":5},
        component:() => import('../views/month-card/sell-record')
    },
    {
        "path":"/month-card/my-card-detail",
        "name":"month-card-my-card-detail",
        "meta":{"title":"权益卡详情","headerType":5},
        component:() => import('../views/month-card/my-card-detail')
    },
    {
        "path":"/month-card/card-transfer",
        "name":"month-card-card-transfer",
        "meta":{"title":"卡转让","headerType":5},
        component:() => import('../views/month-card/card-transfer')
    },
    // 团课月卡详情
    {
        "path":"/month-card/my-schedule-detail",
        "name":"month-card-my-schedule-detail",
        "meta":{"title":"团课会员卡","headerType":5},
        component:() => import('../views/month-card/my-schedule-detail')
    },
    {
        "path":"/month-card/sign-rule",
        "name":"month-card-sing-rule",
        "meta":{"title":"限定免费团课签到规则","headerType":5},
        component:() => import('../views/month-card/sign-rule')
    },
    {
        "path":"/month-card/equity-detail",
        "name":"month-card-equity",
        "meta":{"title":"包含权益","headerType":5},
        component:() => import('../views/month-card/equity-detail')
    },
    {
        "path":"/month-card/use-record",
        "name":"month-card-use-record",
        "meta":{"title":"券包","headerType":5},
        component:() => import('../views/month-card/use-record')
    },
    {
        "path":"/month-card/suspend-record",
        "name":"month-card-suspend-record",
        "meta":{"title":"权益卡冻结记录","headerType":5},
        component:() => import('../views/month-card/suspend-record')
    },
    {
        "path":"/month-card/use-record-self",
        "name":"month-card-use-record-self",
        "meta":{"title":"使用情况","headerType":5},
        component:() => import('../views/month-card/use-record-self')
    },
    {
        "path":"/month-card/equity-gift/list",
        "name":"equity-gift",
        "meta":{"title":"赠送优惠券","headerType":5},
        component:() => import('../views/month-card/equity-gift/list')
    },
    {
        "path":"/month-card/equity-gift/receive",
        "name":"equity-gift",
        "meta":{"title":"领取优惠券","headerType":5},
        component:() => import('../views/month-card/equity-gift/receive')
    },
    {
        "path":"/month-card/friend",
        "name":"month-card-friend",
        "meta":{"title":"送你一张超鹿运动亲友卡","headerType": 4},
        component:() => import('../views/month-card/friend')
    },
    {
        path: '/month-card/friend-trial/receive',
        name: 'month-card-friend-trial-receive',
        meta: { title: '送你新人体验券', headerType: 5 },
        component: () => import('../views/month-card/friend-trial/receive.vue')
    },
    {
        "path":"/createQrcode",
        "name":"createQrcode",
        "meta":{"title":"生成二维码","headerType":5},
        component:() => import('../views/createQrcode')
    },
    // 赠送月卡给好友
    {
        "path":"/give-equity-card",
        "name":"give-equity-card",
        "meta":{"title":"发送卡券红包","headerType":4},
        component:() => import('../views/give-equity-card/index')
    },
    // 赠送月卡给好友
    {
        "path":"/give-equity-card/record",
        "name":"give-equity-card-record",
        "meta":{"title":"赠礼记录","headerType":4},
        component:() => import('../views/give-equity-card/record')
    },
    { "path": "/appEmptyPage", "name": "appEmptyPage", "meta": { "title": "课包抵扣券", "headerType": 2 }, component: () => import('../views/appEmptyPage') },
    { "path": "/superdeer-activity/banner/cash-voucher", "name": "cash-voucher", "meta": { "title": "超鹿运动", "headerType": 2 }, component: () => import('../views/superdeer-activity/banner/cash-voucher') },
    { "path": "/mini-team/my-team", "name": "mini-team-my-team", "meta": { "title": "我的战队", "headerType": 5 }, component: () => import('../views/mini-team/my-team.vue') },
    { "path": "/feedback-record", "name": "feedback-record", "meta": { "title": "反馈记录", "headerType": 5, keepAlive: true }, component: () => import('../views/feedback-record/index.vue') },
    { "path": "/feedback-record/detail", "name": "feedback-record-detail", "meta": { "title": "反馈详情", "headerType": 5 }, component: () => import('../views/feedback-record/detail.vue') },
    { "path": "/feedback-record/scratch", "name": "feedback-record-scratch", "meta": { "title": "反馈赢好礼", "headerType": 5 }, component: () => import('../views/feedback-record/scratch.vue') },
    { "path": "/membership-rule", "name": "membership-rule", "meta": { "title": "等级规则", "headerType": 5 }, component: () => import('../views/membership/rule.vue') },

]
module.exports = routes
